import { CmsDownload } from './CmsDownload';

type CmsDownloadsProps = {
  assetIds: string[];
};

export function CmsDownloads({ assetIds }: CmsDownloadsProps) {
  return (
    <>
      {assetIds.map(id => (
        <CmsDownload entityId={id} key={`attachment_${id}`} as="li" />
      ))}
    </>
  );
}
